module.exports = __webpack_public_path__ + "static/media/login-background.30cf807f.svg";